import { render, staticRenderFns } from "./RunningJoinRequestDataTable.vue?vue&type=template&id=74a14abd"
import script from "./RunningJoinRequestDataTable.vue?vue&type=script&lang=js"
export * from "./RunningJoinRequestDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports